import { Star, Facebook } from "lucide-react";
import { Reveal, ChapterHeading } from "./Reveal";

const REVIEWS = [
  {
    name: "Chantelle M.",
    date: "February 2025",
    text: "If you are wanting to get into shape, Tammy Porter from Me 1st Fitness & Coaching will get you where you want to be. She pushes you to become the best version of yourself — thanks Tammy, you are a blessing!",
  },
  {
    name: "Jenna S.",
    date: "February 2025",
    text: "I constantly share Tammy to everyone who is looking for a trainer!! She is funny and fun but will make sure you stay on track!!! Straight to it — she is AWESOME!",
  },
  {
    name: "Angie M.",
    date: "February 2025",
    text: "Tammy has been helping me with meeting my goals for a few weeks now and the scale is not only moving down, but I feel so much better. She's motivating and fun. If you get a chance to work with her — DO IT!",
  },
  {
    name: "Jenna M.",
    date: "February 2025",
    text: "The knowledge Tammy has for nutrition and what workouts will help you feel your best is amazing. I love that she is helping you put in the work for a long healthy life, not a quick weight loss that is not sustainable.",
  },
  {
    name: "Angela H.",
    date: "May 2023",
    text: "Tammy's classes are my favourite!! She always prepares new material for every class and makes sure to push you that extra you need. I always leave feeling great — and my abs usually hurt from laughing so much. Thanks Tammy!",
  },
  {
    name: "Jessica F.",
    date: "February 2025",
    text: "Amazing coaching to get you to achieve your goals. I am currently working towards mine and she keeps me in line. Would highly recommend to anyone who is looking to start their fitness journey and see success.",
  },
];

const Stars = () => (
  <div className="flex gap-1" aria-label="5 star rating">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} size={16} className="fill-brand text-brand" />
    ))}
  </div>
);

const Testimonials = () => (
  <section id="testimonials" className="py-24 sm:py-32 bg-mint" data-testid="testimonials-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-12 items-end mb-14">
        <div className="lg:col-span-7">
          <ChapterHeading number="05" label="Reviews" title="Real People. Real Journeys." />
        </div>
        <Reveal delay={0.1} className="lg:col-span-5">
          <div className="flex items-end gap-5 lg:justify-end" data-testid="recommendation-stat">
            <p className="font-display font-black leading-none text-charcoal text-[6rem] sm:text-[8rem]">
              94<span className="text-brand">%</span>
            </p>
            <div className="pb-4">
              <Stars />
              <p className="mt-2 text-sm font-medium text-charcoal/60 max-w-[12rem]">
                of clients recommend Me 1st Fitness — based on 14 reviews
              </p>
            </div>
          </div>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {REVIEWS.map((t, i) => (
          <Reveal key={t.name} delay={0.06 * i}>
            <figure
              className="h-full rounded-3xl bg-charcoal border border-sand/10 shadow-[0_8px_30px_rgb(0,0,0,0.08)] p-8 flex flex-col"
              data-testid={`testimonial-card-${i}`}
            >
              <Stars />
              <blockquote className="mt-5 flex-1 text-sand/75 leading-relaxed">
                "{t.text}"
              </blockquote>
              <figcaption className="mt-6 flex items-center justify-between">
                <div>
                  <p className="font-display font-bold text-sand">{t.name}</p>
                  <p className="text-xs text-sand/50">{t.date}</p>
                </div>
                <span className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-[0.15em] font-bold text-sand/40">
                  <Facebook size={12} /> Facebook
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
